import React from 'react';
import { useLocalizedData } from '../hooks/useTranslatedContent';

function ThirdBanner({ aboutData }) {
    const { getLocalizedFirstItem, getLocalizedArray } = useLocalizedData(aboutData);

    if (!aboutData) return null;

    const thirdImageItem = getLocalizedFirstItem('thirdImage');
    const backgroundImage = thirdImageItem?.img || '';
    const description = thirdImageItem?.description || "";
    const logos = getLocalizedArray('thirdBanner') || [];

    return (
        <section
            className="relative py-10 px-3 md:px-8"
            style={{
                backgroundImage: `url("${backgroundImage}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                position: 'relative',
                bottom: '1px',
            }}
        >
            <div className="absolute inset-0 bg-slate-950 opacity-80" />

            <div className="relative max-w-7xl mx-auto text-center">
                {description && (
                    <p
                        className="text-xl md:text-2xl font-semibold text-white mb-6 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                )}


                {logos.length > 0 && (
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 py-4">
                        {logos.map((item, index) => (
                            <a
                                key={item.id || `logo-${index}`}
                                href={item.imgLink || ''}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="flex items-center justify-center"
                                aria-label={item.title || ""}
                            >
                                <img
                                    src={item.img || ''}
                                    alt={item.title || `Partner logo ${index + 1}`}
                                    className="max-h-24 w-auto object-contain hover:scale-105 transition-transform duration-300"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </a>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default ThirdBanner;